export default "__VITE_ASSET__WIB6XqW0__"